const alsoRouters = [
  '/',
  '/404',
  '/operation',
  '/errors/result/success',
  '/result/success',
  '/errors/result/succeed',
  '/errors/result/parent-result',
  '/universalPage/:encodedURL',
];

function getUrlData(data, routeKey, childKey) {
  const urlArray = [];
  function generateUrlData(data) {
    data &&
      data.forEach(item => {
        if (item[routeKey]) {
          urlArray.push(item[routeKey]);
        }
        if (item[childKey]) generateUrlData(item[childKey]);
      });
  }
  generateUrlData(data);
  return urlArray;
}
/*
  @param {Arrray} uacMenus
  处理UAC的所有节点数据，拿到所有UAC路由menuURL数组
  返回[router1,router2...]
*/
export const getAllAllowedRoutes = uacMenus => {
  const allUacRoutes = getUrlData(uacMenus, 'menuURL', 'childrenMenuList');
  if (allUacRoutes.includes('/no-uac-auth') && !allUacRoutes.includes('/')) {
    return allUacRoutes.concat(alsoRouters).filter(i => i !== '/');
  }
  // 所有项目允许访问error、成功提示等路由
  return allUacRoutes.concat(alsoRouters);
};

/*
  @param {Arrray} routes
  处理router.config.js中的配置路由数据，拿到所有路由path数组
  返回[router1,router2...]
*/
export const getRouterConfigPath = routes => {
  return getUrlData(routes, 'path', 'routes');
};

/*
  @param {Arrray} routes
  @param {Arrray} allAllowedRoutesByUac
  处理router.config.js中的配置路由数据，过滤掉UAC没有权限的路由
  返回routes数据
*/
export const getRouteFilterByUac = (routes, allAllowedRoutesByUac) => {
  function filterData(data) {
    const r = data.filter(item => {
      // 属于uac权限路由和router.config中自定义的无path的组件
      const active = (item.path && allAllowedRoutesByUac.indexOf(item.path) > -1) || !item.path;
      if (item.routes && active) item.routes = filterData(item.routes);
      return active;
    });
    return r;
  }
  return filterData(routes || []) || [];
};

export function getSwimlane(url) {
  const arr = url.match(/^https?:\/\/([.\w-]+)-sl-/);
  return arr ? arr[1] : null;
}
